import { animate, onScroll } from "animejs";

class Animations {
	constructor() {
		let cache = {};
		let animations = {};

		let initFunc = () => {
			initCache();
			setupAnimations();
		};

		let initCache = () => {
			cache.fadeIn = document.querySelectorAll(".animate-fade-in");
			cache.fadeUp = document.querySelectorAll(".animate-fade-up");
			cache.fadeLeft = document.querySelectorAll(".animate-fade-left");
			cache.fadeRight = document.querySelectorAll(".animate-fade-right");
			cache.lineCards = document.querySelectorAll(".layout-bg .guides .card:nth-child(1), .layout-bg .guides .card:nth-child(2)");
		};

		let setupAnimations = () => {
			setupFadeIn();
			setupFadeUp();
			setupFadeLeft();
			setupFadeRight();
			setupLineAnimation();
		};

		let setupFadeIn = () => {
			if (!cache.fadeIn || cache.fadeIn.length === 0) return;

			cache.fadeIn.forEach((element, index) => {
				const delay = parseInt(element.dataset.animationDelay || 0);
				const duration = parseInt(element.dataset.animationDuration || 600);

				animations[`fadeIn_${index}`] = animate(element, {
					opacity: [0, 1],
					duration: duration,
					delay: delay,
					easing: "outCubic",
					autoplay: onScroll({
						target: element,
						enter: "bottom 40%",
						once: true,
					}),
				});
			});
		};

		let setupFadeUp = () => {
			if (!cache.fadeUp || cache.fadeUp.length === 0) return;

			cache.fadeUp.forEach((element, index) => {
				const delay = parseInt(element.dataset.animationDelay || 0);
				const duration = parseInt(element.dataset.animationDuration || 700);
				const distance = parseInt(element.dataset.animationDistance || 30);

				animations[`fadeUp_${index}`] = animate(element, {
					opacity: [0, 1],
					translateY: [distance, 0],
					duration: duration,
					delay: delay,
					easing: "outCubic",
					autoplay: onScroll({
						target: element,
						enter: "bottom 40%",
						once: true,
					}),
				});
			});
		};

		let setupFadeLeft = () => {
			if (!cache.fadeLeft || cache.fadeLeft.length === 0) return;

			cache.fadeLeft.forEach((element, index) => {
				const delay = parseInt(element.dataset.animationDelay || 0);
				const duration = parseInt(element.dataset.animationDuration || 700);
				const distance = parseInt(element.dataset.animationDistance || 40);

				animations[`fadeLeft_${index}`] = animate(element, {
					opacity: [0, 1],
					translateX: [-distance, 0],
					duration: duration,
					delay: delay,
					easing: "outCubic",
					autoplay: onScroll({
						target: element,
						enter: "bottom 40%",
						once: true,
					}),
				});
			});
		};

		let setupFadeRight = () => {
			if (!cache.fadeRight || cache.fadeRight.length === 0) return;

			cache.fadeRight.forEach((element, index) => {
				const delay = parseInt(element.dataset.animationDelay || 0);
				const duration = parseInt(element.dataset.animationDuration || 700);
				const distance = parseInt(element.dataset.animationDistance || 40);

				animations[`fadeRight_${index}`] = animate(element, {
					opacity: [0, 1],
					translateX: [distance, 0],
					duration: duration,
					delay: delay,
					easing: "outCubic",
					autoplay: onScroll({
						target: element,
						enter: "bottom 40%",
						once: true,
					}),
				});
			});
		};

		let setupLineAnimation = () => {
			if (!cache.lineCards || cache.lineCards.length === 0) return;

			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add('animate-line');
						observer.unobserve(entry.target);
					}
				});
			}, {
				threshold: 0.3,
				rootMargin: '0px 0px -15% 0px'
			});

			cache.lineCards.forEach(card => {
				observer.observe(card);
			});
		};

		initFunc();
	}
}

export { Animations };
